webpackJsonp([25],{

/***/ 2715:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = __webpack_require__(773);

var _jquery2 = _interopRequireDefault(_jquery);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(272);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactIntl = __webpack_require__(761);

var _user_actions = __webpack_require__(781);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _back_button = __webpack_require__(852);

var _back_button2 = _interopRequireDefault(_back_button);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var PasswordResetSendLink = function (_React$Component) {
    (0, _inherits3.default)(PasswordResetSendLink, _React$Component);

    function PasswordResetSendLink(props) {
        (0, _classCallCheck3.default)(this, PasswordResetSendLink);

        var _this = (0, _possibleConstructorReturn3.default)(this, (PasswordResetSendLink.__proto__ || (0, _getPrototypeOf2.default)(PasswordResetSendLink)).call(this, props));

        _this.handleSendLink = _this.handleSendLink.bind(_this);

        _this.state = {
            error: '',
            updateText: ''
        };
        return _this;
    }

    (0, _createClass3.default)(PasswordResetSendLink, [{
        key: 'handleSendLink',
        value: function handleSendLink(e) {
            var _this2 = this;

            e.preventDefault();

            var email = _reactDom2.default.findDOMNode(this.refs.email).value.trim().toLowerCase();
            if (!email || !Utils.isEmail(email)) {
                this.setState({
                    error: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'password_send.error',
                        defaultMessage: 'Please enter a valid email address.'
                    })
                });
                return;
            }

            // End of error checking clear error
            this.setState({
                error: ''
            });

            (0, _user_actions.sendPasswordResetEmail)(email, function () {
                _this2.setState({
                    error: null,
                    updateText: _react2.default.createElement(
                        'div',
                        { className: 'reset-form alert alert-success' },
                        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                            id: 'password_send.link',
                            defaultMessage: 'If the account exists, a password reset email will be sent to: <br/><b>{email}</b><br/><br/>',
                            values: {
                                email: email
                            }
                        }),
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'password_send.checkInbox',
                            defaultMessage: 'Please check your inbox.'
                        })
                    )
                });
                (0, _jquery2.default)(_reactDom2.default.findDOMNode(_this2.refs.reset_form)).hide();
            }, function (err) {
                _this2.setState({
                    error: err.message,
                    update_text: null
                });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var error = null;
            if (this.state.error) {
                error = _react2.default.createElement(
                    'div',
                    { className: 'form-group has-error' },
                    _react2.default.createElement(
                        'label',
                        { className: 'control-label' },
                        this.state.error
                    )
                );
            }

            var formClass = 'form-group';
            if (error) {
                formClass += ' has-error';
            }

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_back_button2.default, null),
                _react2.default.createElement(
                    'div',
                    { className: 'col-sm-12' },
                    _react2.default.createElement(
                        'div',
                        { className: 'signup-team__container' },
                        _react2.default.createElement(
                            'h3',
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'password_send.title',
                                defaultMessage: 'Password Reset'
                            })
                        ),
                        this.state.updateText,
                        _react2.default.createElement(
                            'form',
                            {
                                onSubmit: this.handleSendLink,
                                ref: 'reset_form'
                            },
                            _react2.default.createElement(
                                'p',
                                null,
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'password_send.description',
                                    defaultMessage: 'To reset your password, enter the email address you used to sign up'
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: formClass },
                                _react2.default.createElement('input', {
                                    type: 'email',
                                    className: 'form-control',
                                    name: 'email',
                                    ref: 'email',
                                    placeholder: Utils.localizeMessage('password_send.email', 'Email'),
                                    spellCheck: 'false'
                                })
                            ),
                            error,
                            _react2.default.createElement(
                                'button',
                                {
                                    type: 'submit',
                                    className: 'btn btn-primary'
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'password_send.reset',
                                    defaultMessage: 'Reset my password'
                                })
                            )
                        )
                    )
                )
            );
        }
    }]);
    return PasswordResetSendLink;
}(_react2.default.Component);

PasswordResetSendLink.defaultProps = {};
PasswordResetSendLink.propTypes = {
    params: _propTypes2.default.object.isRequired
};

exports.default = PasswordResetSendLink;

/***/ })

});


// WEBPACK FOOTER //
// 25.a97a46673866b824ada6.js